import React, { useMemo, useRef } from "react";

import { HvDropdownProps } from "@hitachivantara/uikit-react-core";

import { Priority } from "lib/api";
import LevelBadge from "components/common/LevelBadge";
import BaseDropdown from "../BaseDropdown";

import useStyles from "./styles";

interface PriorityDropdownProps extends Omit<HvDropdownProps, "values"> {
  priorities?: Priority[];
  defaultValue?: number;
}

const PriorityDropdown = ({
  priorities,
  defaultValue,
  ...other
}: PriorityDropdownProps): JSX.Element => {
  const classes = useStyles();

  const initialSelectedRef = useRef(defaultValue);
  const dropdownValues = useMemo(
    () =>
      priorities?.map((r) => ({
        id: r.pk_prt_id.toString(),
        label: (
          <LevelBadge
            color={r.prt_color}
            textIcon={`P${r.inc_priority_order}`}
            name={r.prt_name}
          />
        ),
        searchValue: r.prt_name,
        selected:
          initialSelectedRef.current != null
            ? initialSelectedRef.current === r.pk_prt_id
            : r.prt_is_default,
      })),
    [priorities]
  );

  return (
    <BaseDropdown
      classes={{
        placeholder: classes.placeholder,
      }}
      values={dropdownValues}
      singleSelectionToggle={false}
      {...other}
    />
  );
};

export default PriorityDropdown;
